import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import useDevice from '../hooks/useDevice';

import '../App.css';
import UserInfo from './UserInfo';

export default function ResponsiveLayout({ children }) {
  const device = useDevice();
  const [open, setOpen] = useState(false);

  return (
    <div className={`App device-${device}`}>
      <nav className="topnav" style={{display:'flex',alignItems:'center',justifyContent:'space-between'}}>
        <div style={{flex:1}}>
        {device === 'mobile' ? (
          <>
            <button className="menu-btn" onClick={() => setOpen(!open)}>{open ? '关闭' : '菜单'}</button>
            {open && (
              <div className="navlinks mobile">
                <Link to="/display" onClick={() => setOpen(false)}>展示</Link>
                <Link to="/transactions" onClick={() => setOpen(false)}>交易</Link>
                <Link to="/items" onClick={() => setOpen(false)}>商品</Link>
                <Link to="/customers" onClick={() => setOpen(false)}>客户</Link>
                <Link to="/vendors" onClick={() => setOpen(false)}>供应商</Link>
              </div>
            )}
          </>
        ) : (
          <div className="navlinks">
            <Link to="/display">展示</Link>
            <Link to="/transactions">交易</Link>
            <Link to="/items">商品</Link>
            <Link to="/customers">客户</Link>
            <Link to="/vendors">供应商</Link>
          </div>
        )}
        </div>

        <UserInfo />
      </nav>

      <main className="container">{children}</main>

      <footer className="footer">Inventory UI</footer>
    </div>
  );
}
